import { Dashboard } from "@mui/icons-material";
import { useLocalStorage } from "usehooks-ts";
import { DashboardMode } from "../../utils/enums/Dashboard";
import {
  CLEANING_MODE_ENABLED,
  TASK_MODE_QUERY_PARAM,
} from "../../utils/const";
import { useEffect, useState } from "react";

export const useDashboardMode = () => {
  const [dashboardMode, setDashboardMode, removeDashboardMode] =
    useLocalStorage(TASK_MODE_QUERY_PARAM, DashboardMode.DELIVERY);

  return {
    dashboardMode: CLEANING_MODE_ENABLED
      ? dashboardMode
      : DashboardMode.DELIVERY,
    setDashboardMode,
    removeDashboardMode,
    isCleaningMode: dashboardMode === DashboardMode.CLEANING,
    isDeliveryMode:
      dashboardMode === DashboardMode.DELIVERY || !CLEANING_MODE_ENABLED,
  };
};

const useOnlineStatus = () => {
  // Set the initial state based on the current navigator.onLine value
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Handlers to update the state when events fire
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    // Add event listeners to the window object
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Cleanup function to remove event listeners when the component unmounts
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []); // Empty dependency array ensures the effect runs only once on mount

  // Return the current online status
  return {
    isOnline
  }
};

export default useOnlineStatus;
